import React from 'react';
import { cn } from '../../lib/cn';

export function ProgressBar({ value, gradient }: { value: number; gradient?: boolean }) {
  return (
    <div className="h-2 overflow-hidden rounded bg-[var(--cream-2)]">
      <div
        className={cn('h-full rounded transition-[width] duration-[600ms]', !gradient && 'bg-[var(--sage-0)]')}
        style={{
          width: `${String(value)}%`,
          ...(gradient ? { background: 'var(--grad-spectrum)' } : {}),
        }}
      />
    </div>
  );
}
export type ProgressBarProps = React.ComponentProps<typeof ProgressBar>;
